<template>
  <div class="dsfa-sc-todo-work">
    <DsfSCPanel
      :title="title"
      :search="true"
      :setting="true"
      :more="moreConfig.show"
      :moreConfig="moreConfig"
      :badge="badge"
    >
      <div class="dsfa-sc-todo-work-content">
        <dsf-virtual-scroll scroll-Y>
          <DsfSCTodoWorkList :dataList="dataList"></DsfSCTodoWorkList>
        </dsf-virtual-scroll>
      </div>
    </DsfSCPanel>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCTodoWork",
  ctrlCaption: "待办事项",
  mixins: [$mixins.control],
  data() {
    return {
      dataList: [],
      title: "",
      badge: 0,
      moreConfig: {},
    };
  },
  created() {
    this.$http.get("/static/data/dsf.sctodowork.json").then(({ data }) => {
      this.dataList = data.dataList;
      this.title = data.title || "待办事项";
      this.badge = data.badge || 0;
      this.moreConfig = data.moreConfig || {};
    });
  },
  methods: {},
});
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/todoWork.scss';
</style>